import React from 'react';
import DataTable from 'components/DataTable'
import MuiPaper from '@material-ui/core/Paper';

import {
    Edit as EditIcon,
} from '@material-ui/icons'

import styled from 'styled-components';
import { useTranslation } from 'react-i18next'

import Biblios from 'data/Biblios';
import Image from 'components/Img'

import { sortAlphaNum } from 'Util/Sorting'

const Paper = styled(MuiPaper)`
    padding: 10px;
`

export default ({ data = Biblios, actions, onChange, onClickEdit, headerActions }) => {

    const { t } = useTranslation();


    data.sort(function (a, b) {

        if ( a.archive && b.archive ) {
            return sortAlphaNum(a.archive.toLowerCase(), b.archive.toLowerCase())
        }
        return -1
    });

    return (
        <Paper elevation={3}>

            {headerActions && (
                <div>
                    {headerActions}
                </div>
            )}

            <DataTable
                data={data}
                config={{
                    cells: [
                        { title: t('nb_archive'), key: 'archive', bold:true, width:'100px' },
                        { title: t('auteur'), key: 'auteurs', width:'150px' },
                        { title: t('title'), key: 'titre' },
                        { title: t('annee'), key: 'annee', width:'80px' },
                        { title: t('exemplaires'), key: 'nb_exemplaires', width:'100px'  },
                    ],
                    actions: actions || [
                        {
                            icon: <EditIcon />, title: "Edit",
                            onClick: (id, biblio) => {
                                window.open("/biblio/" + biblio.objectid)
                            }
                        }
                    ]
                }}
                getCell={(item, attr_name) => {

                    if (attr_name === "filename") {
                        return (
                            <Image
                                imageWidth={60}
                                style={{justifyContent: 'flex-start'}}
                                alt="" filename={item.filename}
                            />
                        )
                    }
                    return Object.prototype.hasOwnProperty.call(item, attr_name) ? item[attr_name] : '';
                }}
            />
        </Paper>


    )
}